export type AppEnvironment = 'development' | 'staging' | 'production';

const rawEnvironment = process.env.EXPO_PUBLIC_APP_ENV;

export const appEnvironment: AppEnvironment =
  rawEnvironment === 'production' || rawEnvironment === 'staging' ? rawEnvironment : 'development';

export const isProduction = appEnvironment === 'production';
export const liveDataEnabled = process.env.EXPO_PUBLIC_LIVE_DATA === 'true' && !isProduction;
export const productionReady = process.env.EXPO_PUBLIC_PRODUCTION_READY === 'true';
export const productionLocked = isProduction && !productionReady;
export const buildTargetMarker = isProduction ? 'BLONDE_RUNTIME_PRODUCTION' : 'BLONDE_RUNTIME_NONPRODUCTION';
export const allowLocalOperationalState =
  !isProduction && process.env.EXPO_PUBLIC_ALLOW_LOCAL_OPERATIONAL_STATE !== 'false';

function secureUrl(value?: string) {
  const normalized = value?.trim().replace(/\/+$/, '') ?? '';
  if (!normalized) return '';
  if (isProduction && !normalized.startsWith('https://')) throw new Error('Production URLs must use HTTPS.');
  return normalized;
}

export const apiBaseUrl = secureUrl(process.env.EXPO_PUBLIC_API_BASE_URL);
export const configuredAppUrl = secureUrl(process.env.EXPO_PUBLIC_APP_URL);
export const supabaseUrl = secureUrl(process.env.EXPO_PUBLIC_SUPABASE_URL);
export const supabasePublishableKey = process.env.EXPO_PUBLIC_SUPABASE_PUBLISHABLE_KEY?.trim() ?? '';

export function apiUrl(path: string) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiBaseUrl}${normalizedPath}`;
}
